import axios from 'axios';
import { Configuration } from '../Configuration';

axios.defaults.withCredentials = true;

// TODO Create React Custom Hook?
export default axios.create({
	baseURL: Configuration.backendUrl,
});
